import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const haveError = (_, { payload: error }) => error;

const clearState = () => null;

export default createReducer(initialState, {
  [types.FETCH_DEALER_REQUEST]: clearState,
  [types.FETCH_DEALERS_REQUEST]: clearState,
  [types.CREATE_DEALER_REQUEST]: clearState,
  [types.CHANGE_DEALER_STATUS_REQUEST]: clearState,
  [types.FETCH_DEALERS_SELECT_REQUEST]: clearState,
  [types.FETCH_DEALERS_BY_REDUCER_REQUEST]: clearState,

  [types.FETCH_DEALER_FAILURE]: haveError,
  [types.FETCH_DEALERS_FAILURE]: haveError,
  [types.FETCH_DEALERS_SELECT_FAILURE]: haveError,
  [types.CREATE_DEALER_FAILURE]: haveError,
  [types.CHANGE_DEALER_STATUS_FAILURE]: haveError,

  [types.FETCH_DEALER_SUCCESS]: clearState,
  [types.FETCH_DEALERS_SUCCESS]: clearState,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: clearState,
  [types.CREATE_DEALER_SUCCESS]: clearState,
  [types.CHANGE_DEALER_STATUS_SUCCESS]: clearState,

  [types.UPDATE_DEALER_REQUEST]: clearState,
  [types.UPDATE_DEALER_FAILURE]: haveError,
  [types.UPDATE_DEALER_SUCCESS]: clearState,
});
